import React, { Component } from "react";
import "./Home.css";
import CountryCard from "../../components/content/country-card/CountryCard";
import axios from "axios";
import Search from "../../components/content/search/Search";
import DropDown from "../../components/content/dropdown/DropDown";
import Loader from "../../components/content/loader/Loader";

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      countries: [],
      loader: false,
    };

    this.debounceTimeout = null;
  }

  /**
   * Accepts boolean value and set it to the state variable 'loader'
   * @param {boolean} status
   */
  toggleLoader = (status) => {
    this.setState({ loader: status });
  };

  /**
   * Get all country list in JSON format using axios
   * store it inside state variable countries
   * handle http errors if any using try catch
   */
  getAllCountries = async () => {
    this.toggleLoader(true);
    try {
      let response = await axios.get("/all");

      this.setState({ countries: response.data });
      this.toggleLoader(false);
    } catch (e) {
      alert("Server not responding!");
    }
  };

  /**
   * Get all country list by its region name in JSON format using axios
   * store it inside state variable countries
   * handle http errors if any using try catch
   * @param {string} region
   */
  getCountriesByRegion = async (region) => {
    this.toggleLoader(true);
    try {
      let response = await axios.get(`/region/${region}`);

      this.setState({ countries: [...response.data] });
      this.toggleLoader(false);
    } catch (e) {
      alert("Server not responding!");
      this.toggleLoader(false);
    }
  };

  /**
   * This is the function that is called whenever the user types or changes the text in the searchbar field
   * We need to make sure that the search handler isn't constantly called for every key press, so we debounce the logic
   */
  debounceSearch = (event) => {
    let text = event.target.value;

    if (this.debounceTimeout) clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      this.getCountriesByName(text);
    }, 300);
  };

  /**
   * Get all country list by its country name in JSON format using axios
   * store it inside state variable countries
   * handle http errors if any using try catch
   * @param {string} region
   */
  getCountriesByName = async (name) => {
    if (name !== "") {
      this.toggleLoader(true);
      try {
        let response = await axios.get(`/name/${name}`);

        this.setState({ countries: [...response.data] });
        this.toggleLoader(false);
      } catch (e) {
        alert("Server not responding!");
        this.toggleLoader(false);
      }
    } else {
      this.getAllCountries();
    }
  };

  /**
   * Whenever component is mounted getAllCountries method will get called
   * get all countries initially
   */
  componentDidMount() {
    this.getAllCountries();
  }

  render() {
    return (
      <div id="home" className="container mt-4">
        <div className="search__dropdown">
          {/* Search component is mounted with debounce functionality */}
          <Search onNameChange={this.debounceSearch} />
          {/* dropdown component mounted to sort countries by region */}
          <DropDown
            onRegionChange={(region) => this.getCountriesByRegion(region)}
          />
        </div>
        {this.state.loader ? (
          <Loader />
        ) : (
          <div className="row">
            {this.state.countries.map((country) => (
              <div
                className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-5"
                key={country.alpha3Code}
              >
                {/* CountryCard component is used to display all the countries in well manner */}
                <CountryCard {...country} />
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default Home;
